import styled from "@emotion/styled";
import WalletSVG from "../assets/svg/smallOsiris.svg";
import AccountSVG from "../assets/svg/dashboard.svg";
import LogoSVG from "../assets/svg/osiris.svg";
import bgLogoSVG from "../assets/svg/bgLogoOsiris.svg";
import { NavLink, useLocation } from "react-router-dom";
import { SuspenseImg } from "components/SuspenseImg/SuspenseImg";

const Container = styled.div(({ theme }) => ({
  backgroundColor: theme.switch("#467270", "#79C384"),
  width: "220px",
  height: "100%",
  paddingTop: "48px",
  paddingBottom: "48px",
  position: "fixed",
  boxSizing: "border-box",
  top: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  zIndex: 10,
}));

const LogoBlock = styled.div(() => ({
  fontSize: "30px",
  color: "#fff",
  fontWeight: "bold",
  marginBottom: "45px",
  "& img": {
    width: 120,
    marginBottom: 50,
  },
}));

const ImgBlock = styled.div(() => ({
  width: "26px",
  display: "flex",
  alignItems: "center",
}));

const ImgBlockActive = styled(ImgBlock)(({ theme }) => ({
  "& img": {
    filter: theme.switch(
      "invert(73%) sepia(9%) saturate(1535%) hue-rotate(78deg) brightness(95%) contrast(89%)",
      "invert(11%) sepia(4%) saturate(17%) hue-rotate(314deg) brightness(94%) contrast(94%)"
    ),
  },
}));

const ItemText = styled.p(() => ({}));

const Item = styled.div(() => ({
  display: "flex",
  textDecoration: "none",
  gap: "15px",
  alignItems: "center",
  color: "#fff",
  paddingTop: "14px",
  paddingBottom: "14px",
  fontWeight: 600,
  lineHeight: "11px",
  fontSize: "14px",
}));

const ItemActive = styled(Item)(({ theme }) => ({
  width: "200px",
  marginBottom: "0",
  color: theme.switch(theme.colors.dark.purple, "#212121"),
  backgroundColor: theme.switch(
    theme.colors.dark.background,
    theme.colors.light.background
  ),
  marginRight: "-67px",
  marginLeft: "-30px",
  paddingLeft: "30px",
  borderTopLeftRadius: "13px",
  borderBottomLeftRadius: "13px",
}));

const Menu = styled.div(() => ({}));

const Links = styled.div(() => ({
  fontSize: "14px",
  paddingLeft: "23px",
  width: "150px",
  color: "#fff",
  marginLeft: "-20px",
  marginTop: "auto",
  display: "flex",
  alignItems: "center",
  gap: "15px",
  "& img": {
    width: "25px",
  },
}));

const sidebarItems = [
  {
    label: "Main",
    link: "/",
    icon: WalletSVG,
  },
  {
    label: "Dashboard",
    link: "/dashboard",
    icon: AccountSVG,
  },
];

export const Sidebar = () => {
  const location = useLocation();
  return (
    <Container>
      <SuspenseImg
        src={bgLogoSVG}
        style={{ position: "absolute", top: "0", left: "0" }}
      />
      <LogoBlock>AgeWise</LogoBlock>
      <Menu>
        {sidebarItems.map((elem) => {
          if (
            location.pathname === elem.link ||
            location.pathname.includes(elem.link)
          ) {
            return (
              <ItemActive key={elem.link}>
                <ImgBlockActive>
                  <SuspenseImg src={elem.icon} />
                </ImgBlockActive>
                <ItemText>{elem.label}</ItemText>
              </ItemActive>
            );
          }
          return (
            <Item key={elem.link}>
              <ImgBlock>
                <SuspenseImg src={elem.icon} />
              </ImgBlock>
              <ItemText>{elem.label}</ItemText>
            </Item>
          );
        })}
      </Menu>
      <Links>Powered by Osiris</Links>
    </Container>
  );
};
